<v-autocomplete
  hide-details
  density="compact"
  variant="outlined"
  label="spId"
  :items="serviceProviders"
  v-model="spId"
  @update:model-value="$emit('change', $event)"
></v-autocomplete>
